module.exports = __webpack_public_path__ + "img/cta-background.50a02b0c.png";